const getCustomerCategories = (transactions) => {
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  const ninetyDaysAgo = new Date();
  ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

  const customerMap = new Map();

  transactions.forEach((transaction) => {
    const tranDate = new Date(transaction.tran_date);

    if (tranDate >= oneYearAgo) {
      const customer = customerMap.get(transaction.cust_phone) || {
        custName: transaction.cust_name,
        totalSpend: 0,
        purchaseCount: 0,
        lastPurchaseDate: tranDate,
      };

      customer.totalSpend += parseFloat(transaction.total);
      customer.purchaseCount += 1;

      if (tranDate > customer.lastPurchaseDate) {
        customer.lastPurchaseDate = tranDate;
      }

      customerMap.set(transaction.cust_phone, customer);
    }
  });

  const categories = {
    loyalists: [],
    potentialLoyalists: [],
    promising: [],
    hesitant: [],
    needAttention: [],
    detractors: [],
  };

  customerMap.forEach((customer, name) => {
    const recentPurchase = customer.lastPurchaseDate >= thirtyDaysAgo;
    const pastMonthPurchase =
      customer.lastPurchaseDate >= ninetyDaysAgo &&
      customer.lastPurchaseDate < thirtyDaysAgo;
    const lastPurchaseOver90Days = customer.lastPurchaseDate < ninetyDaysAgo;

    // if (
    //   customer.totalSpend >= 5000 &&
    //   customer.purchaseCount >= 5 &&
    //   recentPurchase
    // ) {
    //   categories.loyalists.push(name);
    // } else if (
    //   customer.totalSpend >= 2000 &&
    //   customer.totalSpend < 5000 &&
    //   customer.purchaseCount >= 5 &&
    //   recentPurchase
    // ) {
    //   categories.potentialLoyalists.push(name);
    // } else if (
    //   customer.totalSpend >= 2000 &&
    //   customer.totalSpend < 5000 &&
    //   customer.purchaseCount >= 2 &&
    //   customer.purchaseCount <= 4 &&
    //   recentPurchase
    // ) {
    //   categories.promising.push(name);
    // } else if (
    //   customer.totalSpend < 2000 &&
    //   customer.purchaseCount >= 2 &&
    //   customer.purchaseCount <= 4 &&
    //   recentPurchase
    // ) {
    //   categories.hesitant.push(name);
    // } else if (
    //   customer.totalSpend >= 2000 &&
    //   customer.totalSpend < 5000 &&
    //   customer.purchaseCount >= 2 &&
    //   customer.purchaseCount <= 4 &&
    //   pastMonthPurchase
    // ) {
    //   categories.needAttention.push(name);
    // } else if (
    //   customer.totalSpend < 2000 &&
    //   customer.purchaseCount === 1 &&
    //   lastPurchaseOver90Days
    // ) {
    //   categories.detractors.push(name);
    // }
    const spend = Number(customer.totalSpend || 0);
    const purchases = Number(customer.purchaseCount || 0);

    if (spend >= 10000 || purchases >= 10) {
      categories.loyalists.push(name);
    } else if (
      (spend >= 8000 && spend < 10000) ||
      (purchases >= 8 && purchases < 10)
    ) {
      categories.potentialLoyalists.push(name);
    } else if (
      (spend >= 6000 && spend < 8000) ||
      (purchases >= 6 && purchases < 8)
    ) {
      categories.promising.push(name);
    } else if (
      (spend >= 4000 && spend < 6000) ||
      (purchases >= 4 && purchases < 6)
    ) {
      categories.hesitant.push(name);
    } else if (
      (spend >= 2000 && spend < 4000) ||
      (purchases >= 2 && purchases < 4)
    ) {
      categories.needAttention.push(name);
    } else if ((spend >= 1000 && spend < 2000) || purchases === 1) {
      categories.detractors.push(name);
    }
  });

  return categories;
};

export default getCustomerCategories;
